import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function OriginStorySection() {
  return <section className="py-24 px-6 bg-charcoal-800 relative" data-id="element-126">
      <div className="absolute left-0 top-0 bottom-0 w-2 bg-amber/50" data-id="element-127" />

      <div className="max-w-3xl mx-auto" data-id="element-128">
        <FadeIn data-id="element-129">
          <h2 className="font-heading text-3xl sm:text-4xl text-amber mb-10" data-id="element-130">
            ¿Por qué existe este protocolo?
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-131">
          <div className="space-y-6 text-lg sm:text-xl text-offwhite/90 font-light leading-relaxed" data-id="element-132">
            <p data-id="element-133">
              Esto no lo creó un gurú del bienestar que nunca trabajó en una
              oficina.
            </p>
            <p className="text-offwhite font-medium" data-id="element-134">
              Lo creé porque yo estuve ahí.
            </p>
            <p data-id="element-135">
              Domingo a la noche. Pecho apretado. Tres horas mirando el techo
              sin poder dormir. Llegando a casa y contestando mal por cualquier
              cosa.
            </p>
            <p data-id="element-136">
              Probé meditación. No pude. Probé vacaciones. El estrés me esperó
              en el aeropuerto de vuelta.
            </p>
            <p className="text-offwhite" data-id="element-137">
              Hasta que entendí que el problema no era mi cabeza. Era mi sistema
              nervioso sin protocolo de cierre.
            </p>
            <p className="text-amber font-heading text-2xl sm:text-3xl pt-4" data-id="element-138">
              Ahí nació el Reset de 72 Horas.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}